import { connect } from 'react-redux';

import { NavigationFixedComponent, INavigationFixedStoreProps } from './NavigationFixed';
import { IState } from '../../../store';

export function mapStateToProps(state: IState): INavigationFixedStoreProps {
  return {
    links: state.navigationLinks.links,
    villageName: state.villageData.village.name,
    isFat: state.isFatCard,
  };
}

export const NavigationFixed = connect<INavigationFixedStoreProps>(mapStateToProps)(NavigationFixedComponent);
